<template>
  <div>
    <template v-if="!isCardPagingList">
      <div class="nav-title" :class="{ 'nav-width': sidebarFold ,'nav-height':sidebarTabs}">
        <iframe
          v-if="isIE"
          style="position:absolute;z-index:-1;width:100%;height:100%;top:0;left:0;right:0;bottom:0"
          allowtransparency="true"
          frameborder="0"
        />
        <div class="title">
          {{ $route.meta.title }}
        </div>
        <template v-if="isDetail===true">
          <div class="nav-btn">
            <el-button @click="back">返回</el-button>
            <template v-if="type===0">
              <el-button v-preventReClick type="primary" @click="handleSave">保存</el-button>
            </template>
            <template v-else-if="type===1">
              <el-button v-preventReClick type="primary" @click="handleUpdate">变更</el-button>
            </template>
            <template v-else>
              <!-- <el-button type="primary" @click="$emit('handleSubmit')">提交</el-button> -->
            </template>
          </div>
        </template>
        <template v-else-if="isRefresh">
          <el-select
            v-if="showYearSelect"
            v-model="year"
            @change="yearHandleChange"
          >
            <el-option v-for="(item,index) in yearList" :key="index" :label="item" :value="item" />
          </el-select>
          <el-button v-preventReClick @click="$emit('refresh')">刷新</el-button>
        </template>
        <template v-else-if="isSubmit || isSubmitRefuse || isSubmitConfirm">
          <div class="nav-btn">
            <el-button v-if="isSubmitRefuse" v-preventReClick @click="$emit('refuse')">拒绝</el-button>
            <el-button v-if="isSubmitConfirm" v-preventReClick type="primary" @click="$emit('confirm')">确认</el-button>
            <el-button v-if="isSubmit" v-preventReClick type="primary" @click="$emit('handleSubmit')">提交</el-button>
          </div>
        </template>
        <template v-if="isSaveSubmit">
          <div class="nav-btn">
            <el-button @click="back">返回</el-button>
            <el-button v-preventReClick type="primary" @click="handleSave">保存</el-button>
            <el-button v-preventReClick type="primary" @click="$emit('handleSubmit')">提交</el-button>
          </div>
        </template>
        <template v-if="isBackRefuse">
          <div class="nav-btn">
            <el-button @click="back">返回</el-button>
            <el-button v-preventReClick type="primary" @click="$emit('confirm')">确认</el-button>
            <el-button v-preventReClick @click="$emit('refuse')">拒绝</el-button>
          </div>
        </template>
        <template v-else />
      </div>
    </template>
    <template v-else>
      <div class="nav-title-search" :class="{ 'nav-width': sidebarFold }">
        <div class="title">
          {{ $route.meta.title }}
        </div>
        <div class="search">
          <el-input
            v-model.trim="searchKey"
            class="input"
            :placeholder="placeholder"
            clearable
            maxlength="600"
            @keyup.enter.native="$emit('search',searchKey)"
          />
          <el-button v-preventReClick type="primary" @click="$emit('search',searchKey)">搜索</el-button>
          <el-button v-preventReClick @click="$emit('refresh')">刷新</el-button>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { isIEBrowser } from '@/utils'
export default {
  props: {
    isCardPagingList: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    isRefresh: {
      type: Boolean,
      default: true
    },
    isSubmitRefuse: {
      type: Boolean,
      default: false
    },
    isSubmitConfirm: {
      type: Boolean,
      default: false
    },
    isSubmit: {
      type: Boolean,
      default: false
    },
    // 保存和提交
    isSaveSubmit: {
      type: Boolean,
      default: false
    },
    // 返回和拒绝
    isBackRefuse: {
      type: Boolean,
      default: false
    },
    // 统计页面年度选择展示状态
    showYearSelect: {
      type: Boolean,
      default: false
    },
    // 年度参数
    year: {
      type: String,
      default: new Date().getFullYear().toString()
    },
    // 年度选择下拉列表
    yearList: {
      type: Array,
      default: () => [new Date().getFullYear().toString()]
    },
    type: {
      type: Number,
      default: null
    },
    placeholder: {
      type: String,
      default: '请输入项目编号、项目名称关键字'
    },
    sidebarTabs: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchKey: ''
    }
  },
  computed: {
    sidebarFold: {
      get() {
        // return false
        return this.$store.state.common.sidebarFold
      }
    },
    isIE: {
      get() {
        return isIEBrowser()
      }
    }
  },
  created() {
  },
  activated() {
    this.$nextTick(() => {
      this.searchKey = ''
      if (this.isCardPagingList === true) {
        this.$store.commit('ycyd/updateHeight', '44')
      } else {
        this.$store.commit('ycyd/updateHeight', '0')
      }
    })
  },
  methods: {
    back() {
      this.tabsCloseCurrent()
      if (this.$route.query.noGoBack) {
        this.$router.push({ path: '/index' })
      } else {
        tabsCloseCurrentHandle();
        this.$router.go(-1)
      }
    },
    yearHandleChange(val) {
      this.$emit('update:year', val)
      this.$emit('refresh', val)
    },
    handleSave() {
      this.$emit('save')
    },
    handleUpdate() {
      this.$emit('update')
    }
  }
}
</script>
